module.exports = __webpack_public_path__ + "static/media/logo heart piece.5719a653.png";